module.exports = __webpack_public_path__ + "478c54aee7c7b65ab4fc234712e59704.png";